import {defaultTo, pipe, trim} from 'ramda';

export const getFormPhoneValue = pipe(defaultTo<string | undefined>(''), trim);
